import React from "react";
import { Button } from "react-bootstrap";
import "./Pagination.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) onPageChange(page);
  };

  // Display only few pages (like 1 ... 4 5 6 ... 10)
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 3;

    let start = Math.max(1, currentPage - 1);
    let end = Math.min(totalPages, currentPage + 1);

    if (currentPage <= 2) {
      end = Math.min(totalPages, maxVisible);
    } else if (currentPage >= totalPages - 1) {
      start = Math.max(1, totalPages - (maxVisible - 1));
    }

    if (start > 1) {
      pages.push(
        <Button
          key={1}
          variant={currentPage === 1 ? "primary" : "light"}
          onClick={() => handlePageClick(1)}
        >
          1
        </Button>
      );
      if (start > 2) pages.push(<span key="dots1">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <Button
          key={i}
          variant={i === currentPage ? "primary" : "light"}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </Button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="dots2">...</span>);
      pages.push(
        <Button
          key={totalPages}
          variant={currentPage === totalPages ? "primary" : "light"}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Button>
      );
    }

    return pages;
  };

  return (
    <div className="pagination-modal">
      <Button variant="light" onClick={handlePrev} disabled={currentPage === 1}>
        Prev
      </Button>
      {renderPageNumbers()}
      <Button
        variant="light"
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        Next
      </Button>
    </div>
  );
};

export default Pagination;
